<template>
    <CustomDialog
        v-model="show"
        hideHeader
        hideCloseIcon
        persistent
    >
        <div class="max-mob:px-4 px-7.5 pb-7.5 pt-10 max-mob:py-5 min-w-120 max-mob:min-w-full text-center">
            <TwoFactorAuthIcon class="mx-auto mb-4"/>

            <div class="mb-2 text-gray-370 dark:text-white text-lg font-medium uppercase">
                Two-Factor Authentication Required
            </div>

            <div class="text-gray-200 text-xs">
                To continue using our product, please

                <div class="max-mob:inline">
                    enable two-factor authentication. This will secure
                </div>

                <div class="max-mob:inline">
                    your account and provide full access to all features.
                </div>
            </div>
        </div>

        <template #footer>
            <div class="flex items-center justify-between w-full gap-x-5">
                <LogoutButton/>

                <PrimaryBtn
                    class="w-32.5"
                    @click="onEnableTwoFA"
                >
                    Enable 2FA
                </PrimaryBtn>
            </div>
        </template>
    </CustomDialog>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'

import CustomDialog from '@/components/dialogs/CustomDialog.vue'
import PrimaryBtn from '@/components/buttons/PrimaryBtn.vue'
import LogoutButton from '@/components/buttons/LogoutButton.vue'
import TwoFactorAuthIcon from '@/components/icons/TwoFactorAuthIcon.vue'

import { ROUTES } from '@/constants/routes'

import { useAuthorizationStore } from '@/store/authorizationStore'

const authorizationStore = useAuthorizationStore()

const router = useRouter()

const show = ref(false)

function onEnableTwoFA() {
    show.value = false
    router.push({ name: ROUTES.twoFactorAuth })
}

onMounted(() => {
    show.value = authorizationStore.isRequiredUserTwoFactor
})
</script>
